import { Controller } from "@hotwired/stimulus";
import { Tooltip } from "bootstrap";

// Hover detail on the saved-simulations table. The text is rendered by the
// server from the blob saved with each simulation.
export default class extends Controller {
  connect() {
    this.tooltips = [...this.element.querySelectorAll("[data-bs-toggle='tooltip']")]
      .map((el) => new Tooltip(el, { html: true, customClass: "simulator-tip" }));
  }

  disconnect() {
    this.tooltips.forEach((tooltip) => tooltip.dispose());
    this.tooltips = [];
  }
}
